export default "<div>\n  <button mat-stroked-button [disabled]=\"disabled\" (click)=\"openDialog()\">\n    {{ selectedLanguageText }}\n  </button>\n</div>\n"